import React from "react";
import "./required-documents.css";
import { motion } from "framer-motion";
import { FaIdCard, FaGraduationCap, FaHome, FaFileAlt, FaBriefcase, FaUserShield } from "react-icons/fa";

const RequiredDocuments = () => {
  const documents = [
    { icon: <FaIdCard />, title: "Identity Proof", desc: "Aadhar Card / Passport / Voter ID" },
    { icon: <FaGraduationCap />, title: "Educational Certificates", desc: "Mark sheets & Degree Certificates" },
    { icon: <FaHome />, title: "Address Proof", desc: "Utility Bill / Driving License / Rent Agreement" },
    { icon: <FaBriefcase />, title: "Employment Proof", desc: "Offer Letter / Salary Slips / Employee ID" },
    { icon: <FaUserShield />, title: "Character Certificate", desc: "Issued by recognized authority / institution" },
    { icon: <FaFileAlt />, title: "Other Documents", desc: "Passport-size Photos, Signature, Category Certificate (if applicable)" },
  ];

  return (
    <section className="rd-required-docs-section py-3">
      <div className="container">
        <h2 className="text-center rd-section-title mb-2">Required Documents</h2>
        <p className="text-center rd-section-subtitle mb-5">
          Make sure you have the following before applying
        </p>
        <div className="row justify-content-center">
          {documents.map((doc, index) => (
            <motion.div
              key={index}
              className="col-md-6 mb-4"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <div className="rd-doc-card d-flex align-items-center">
                <div className="rd-doc-icon">{doc.icon}</div>
                <div className="rd-doc-content">
                  <h5>{doc.title}</h5>
                  <p>{doc.desc}</p>
                </div>
                <div className="rd-doc-step">{index + 1}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RequiredDocuments;
